import { connect } from 'react-redux';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import { withTranslation  } from 'react-i18next';
import * as Dictionary from 'Models/Dictionary';
import { submit } from 'redux-form';
import * as UserModule from 'Modules/UserModule';
import { ParentDetails, IParentDetailsProps, CustomProps, ParentDetailsTypeEnum } from 'components/Layout/DetailsSidebar/ParentDetails';

interface IP extends IParentDetailsProps {
    edit: boolean;
    match?: any;
}
interface IConnectedP {
    elStore: UserModule.Types.UserStore;
}
interface IDispatchedP {
    t?: (key: string) => string;
    sendFormSubmit: () => void;
}
type S = {};

export class TerminalInstallationDetails extends ParentDetails<IP & IConnectedP & IDispatchedP, S> {
    constructor(props: IP & IConnectedP & IDispatchedP) {
        super(props);
    }

    public getCustomProps(): CustomProps {
        const { TERMINAL_INSTALLATION } = ViewManagementModule.EnumTypes.Page;

        return {
            ...(this.props as any),
            redirectUrlList: Dictionary.PageUrl.get(TERMINAL_INSTALLATION),
            type: ParentDetailsTypeEnum.SIDEBAR_ONE_ELEMENT
        };
    }

    protected sendForm() {
        this.props.sendFormSubmit();
    }
}

function mapDispachToProps(dispatch: any): IDispatchedP {
    return {
        sendFormSubmit: () => dispatch(submit('terminalInstallationListAddForm'))
    };
}
export default withTranslation (['carDetails', 'forms'])(
    connect(
        null,
        mapDispachToProps
    )(TerminalInstallationDetails) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Layout/DetailsSidebar/TerminalInstallationDetails.tsx